export enum TransportMode {
    AIR = 'AIR',
    OCEAN = 'OCEAN',
    TRUCK = 'TRUCK',
    RAIL = 'RAIL',
}
